/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Sq_Anywhere_EyebrowInputs */

const en_funnel_sq_anywhere_eyebrow = /** @type {(inputs: Funnel_Sq_Anywhere_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One subscription, every device`)
};

const es_funnel_sq_anywhere_eyebrow = /** @type {(inputs: Funnel_Sq_Anywhere_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una suscripción, todos tus dispositivos`)
};

/**
* | output |
* | --- |
* | "One subscription, every device" |
*
* @param {Funnel_Sq_Anywhere_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_sq_anywhere_eyebrow = /** @type {((inputs?: Funnel_Sq_Anywhere_EyebrowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Sq_Anywhere_EyebrowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_sq_anywhere_eyebrow(inputs)
	return en_funnel_sq_anywhere_eyebrow(inputs)
});